function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.19 1.94) scale(1.1119)",
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.5 2.5c0 1.105.672 2 1.5 2s1.5-.895 1.5-2-.672-2-1.5-2-1.5.895-1.5 2z",
  strokeWidth: 0.899
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.11 0 0 1.1234 -2.891 -14.216)",
  cx: 24.227,
  cy: 35.8,
  rx: 19.37,
  ry: 19.139,
  strokeWidth: 0.805
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.257 16.594c-1.357 0-2.457 1.12-2.457 2.5s1.1 2.5 2.457 2.5c.648 0 1.25-.24 1.69-.656a2.466 2.466 0 002.242 1.469c.679 0 1.306-.298 1.75-.75.41.799 1.234 1.343 2.182 1.343.75 0 1.423-.335 1.873-.875.436.698 1.185 1.188 2.058 1.188.783 0 1.485-.389 1.935-.969a2.413 2.413 0 001.997 1.063c.815 0 1.519-.41 1.966-1.032.447.623 1.15 1.032 1.966 1.032.848 0 1.586-.43 2.027-1.094.45.585 1.118 1 1.905 1 .873 0 1.622-.49 2.058-1.188.45.545 1.118.875 1.873.875.957 0 1.775-.563 2.181-1.375.447.472 1.056.782 1.751.782 1.004 0 1.86-.623 2.242-1.5a2.378 2.378 0 001.69.687c1.357 0 2.457-1.12 2.457-2.5s-1.1-2.5-2.457-2.5c-.993 0-1.855.606-2.243 1.469a2.452 2.452 0 00-1.689-.656c-.947 0-1.77.544-2.18 1.343a2.476 2.476 0 00-1.752-.75c-.886 0-1.656.472-2.088 1.188-.451-.532-1.1-.875-1.843-.875-.833 0-1.553.418-1.997 1.062a2.416 2.416 0 00-1.935-.968c-.81 0-1.518.386-1.966 1a2.422 2.422 0 00-1.966-1c-.794 0-1.486.374-1.935.968a2.411 2.411 0 00-1.997-1.062 2.38 2.38 0 00-1.843.875A2.432 2.432 0 0014.121 18c-.695 0-1.304.31-1.751.782-.406-.812-1.224-1.375-2.181-1.375-.662 0-1.248.254-1.69.687-.382-.876-1.24-1.5-2.242-1.5z",
  strokeWidth: 0.899
}));

var SvgChristmasball = function SvgChristmasball(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChristmasball, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Christmas ball.6fc26d3d.svg";
export { ForwardRef as ReactComponent };